<template>
  <el-dialog class="modal-v2" title="修改账号密码" :visible="visible" :before-close="beforeClose" :close-on-click-modal="false" width="500px" append-to-body @closed="closed">
    <el-form ref="ruleForm" class="form-v2" :model="ruleForm" :rules="rules" label-width="110px" style="margin: 40px 0; padding: 0 30px;" size="small" label-suffix="：">
      <el-form-item class="fixed-height" label="原始密码" prop="password">
        <el-input type="password" v-model.trim="ruleForm.password" placeholder="请输入原始密码" clearable maxlength="16"></el-input>
      </el-form-item>
      <el-form-item class="fixed-height" label="新密码" prop="newPassword">
        <el-input type="password" v-model.trim="ruleForm.newPassword" placeholder="请输入新密码" clearable maxlength="16"></el-input>
      </el-form-item>
      <el-form-item class="fixed-height" label="确认新密码" prop="confirmPassword">
        <el-input type="password" v-model.trim="ruleForm.confirmPassword" placeholder="请输入确认密码" clearable maxlength="16"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="w100 flex jbetween acenter">
      <el-button plain class="button-v2" @click="visible = false">取 消</el-button>
      <el-button type="primary" class="button-v2" :loading="submitLoading" @click="submitForm('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { changePassword } from '@/api/user/user';
  let reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
  export default {
    name:'UpdatePassword',
    data(){
      var validatePass = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入密码'));
        } else {
          if (!reg.test(value)) {
            callback(new Error('密码必须8位或以上且是大写字母+小写字母+数字+符号组合！'));
          } else {
            callback();
          }

        }
      };
      var validatePassConfirm = (rule, value, callback) => {
        if (!this.ruleForm.newPassword.trim()) {
        } else {
          if (!value) {
            callback(new Error('请再次输入密码'));
          } else if (value !== this.ruleForm.newPassword) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        }
      };
      return {
        visible: false,
        loadingBtn: false,
        ruleForm:{},
        rules:{
          password: [
            { required: true, message: '请输入原始密码', trigger: 'blur' }
          ],
          newPassword: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { validator: validatePassConfirm, trigger: 'blur' }
          ]
        }
      }
    },
    methods:{
      // 清空表单
      resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
        }
      },
      beforeClose(){
        this.visible = false;
      },
      // 关闭弹窗后
      closed() {
        this.ruleForm = {};
        this.resetForm('ruleForm');
        this.$emit('password-closed');
      },
      // 保存
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if(valid){
            this.loadingBtn = true;
            const params = {
              ...this.ruleForm
            }
            changePassword(params).then(res=>{
              if(res.data.code === 0){
                this.$message.success('修改密码成功');
                this.visible = false;
              } else {
                this.$message.error(res.data.msg);
              }
              this.loadingBtn = false
            }).catch(error => {
              this.loadingBtn = false;
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
